import R from "ramda";
import { BOOTSTRAP_CUSTOM_TABS } from "actions/bootstrap-actions";
import {
  CUSTOM_TAB_CREATED,
  UPDATE_CUSTOM_TAB_NAME,
  START_DELETE_CUSTOM_TAB_MODE,
  END_DELETE_CUSTOM_TAB_MODE,
  CUSTOM_TAB_DELETED,
  CREATE_CUSTOM_TAB_LOADING,
  CREATE_CUSTOM_TAB_LOADING_STOP,
  DELETE_CUSTOM_TAB_LOADING,
  DELETE_CUSTOM_TAB_LOADING_STOP
} from "actions/custom-tabs-actions";

export const initialState = {
  customTabs: [],
  customTabName: "",
  customTabRemoveId: null,
  isCreateCustomTabLoading: false,
  isDeleteCustomTabLoading: false,
  isDeleteCustomTabMode: false
};

export const customTabsReducer = (state = initialState, action) => {
  switch (action.type) {
    case BOOTSTRAP_CUSTOM_TABS:
      return R.merge(state, { customTabs: action.data.customTabs });
    case CUSTOM_TAB_CREATED:
      return stateForCustomTabCreated(state, action);
    case UPDATE_CUSTOM_TAB_NAME:
      return R.merge(state, { customTabName: action.data.name });
    case START_DELETE_CUSTOM_TAB_MODE:
      return R.merge(state, { isDeleteCustomTabMode: true, customTabRemoveId: action.data.id });
    case END_DELETE_CUSTOM_TAB_MODE:
      return R.merge(state, { isDeleteCustomTabMode: false, customTabRemoveId: null });
    case CUSTOM_TAB_DELETED:
      return stateForRemoveCustomTab(state, action);
    case CREATE_CUSTOM_TAB_LOADING:
      return R.merge(state, { isCreateCustomTabLoading: true });
    case CREATE_CUSTOM_TAB_LOADING_STOP:
      return R.merge(state, { isCreateCustomTabLoading: false });
    case DELETE_CUSTOM_TAB_LOADING:
      return R.merge(state, { isDeleteCustomTabLoading: true });
    case DELETE_CUSTOM_TAB_LOADING_STOP:
      return R.merge(state, { isDeleteCustomTabLoading: false });
    default:
      return state;
  }
};

const stateForCustomTabCreated = (state, action) => {
  const newCustomTabs = R.append(action.data.customTab, state.customTabs);
  return R.merge(state, { customTabs: newCustomTabs, customTabName: "" });
};

const stateForRemoveCustomTab = (state, action) => (
  R.merge(state, {
    customTabs: action.data.customTabs,
    isDeleteCustomTabMode: false,
    customTabRemoveId: null
  })
);



// WEBPACK FOOTER //
// ./src/js/reducers/custom-tabs-reducer.js